import React from "react";
import AppraisalList from "pages/AppraisalManagment/Appraisal/AppraisalList";
import Header from "pages/AppraisalManagment/Appraisal/AppraisalList/component/Header/Header";
import "pages/AppraisalManagment/Appraisal/AppraisalProgress.css";

const MonthlyReports = () => {
  return (
    <>
      <Header title="Monthly Appraisals Report" />
      <AppraisalList />
    </>
  );
};

export default MonthlyReports;
